import { useState } from 'react'
import { Button } from '@/components/ui/Button'
import { CsField, CsSection } from '@/components/Cs/CsSection'
import { csFieldClass } from '@/components/Cs/csFormStyles'
import { CS_EXPANSAO_STATUS, type CsAccountDetail } from '@/services/csService'

type Props = {
  account: CsAccountDetail
  onCreate: (payload: {
    tipo: 'UPSELL' | 'CROSS_SELL'
    oportunidade: string
    potencialNota?: string | null
    status?: string
  }) => Promise<void>
  onUpdateStatus: (expansaoId: string, status: string) => Promise<void>
}

export function CsAccountExpansao({ account, onCreate, onUpdateStatus }: Props) {
  const [tipo, setTipo] = useState<'UPSELL' | 'CROSS_SELL'>('UPSELL')
  const [oportunidade, setOportunidade] = useState('')
  const [nota, setNota] = useState('')

  return (
    <CsSection title='Expansão'>
      <div className='mb-4 grid gap-2 md:grid-cols-4'>
        <select className={csFieldClass} value={tipo} onChange={(e) => setTipo(e.target.value as 'UPSELL' | 'CROSS_SELL')}>
          <option value='UPSELL'>Upsell</option>
          <option value='CROSS_SELL'>Cross-sell</option>
        </select>
        <input
          className={`${csFieldClass} md:col-span-2`}
          placeholder='Oportunidade identificada'
          value={oportunidade}
          onChange={(e) => setOportunidade(e.target.value)}
        />
        <Button
          size='sm'
          variant='primary'
          onClick={() => {
            if (!oportunidade.trim()) return
            void onCreate({
              tipo,
              oportunidade: oportunidade.trim(),
              potencialNota: nota.trim() || null,
              status: 'IDENTIFICADA',
            }).then(() => {
              setOportunidade('')
              setNota('')
            })
          }}
        >
          Adicionar
        </Button>
      </div>
      <CsField label='Nota / potencial (texto)'>
        <input className={csFieldClass} value={nota} onChange={(e) => setNota(e.target.value)} />
      </CsField>

      <ul className='space-y-2'>
        {account.expansao.map((item) => (
          <li key={item.id} className='rounded-lg border border-[var(--glass-border)] px-3 py-2 text-sm'>
            <div className='flex flex-wrap items-center justify-between gap-2'>
              <span className='font-semibold'>
                {item.tipo} · {item.oportunidade}
              </span>
              <select
                className={csFieldClass}
                style={{ width: 'auto' }}
                value={item.status}
                onChange={(e) => void onUpdateStatus(item.id, e.target.value)}
              >
                {CS_EXPANSAO_STATUS.map((s) => (
                  <option key={s.value} value={s.value}>
                    {s.label}
                  </option>
                ))}
              </select>
            </div>
            {item.potencialNota && <p className='mt-1 text-[var(--text-muted)]'>{item.potencialNota}</p>}
            {item.potencial != null && (
              <p className='mt-1 text-xs text-accent'>
                Potencial: {item.potencial.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
              </p>
            )}
          </li>
        ))}
        {account.expansao.length === 0 && (
          <p className='text-sm text-[var(--text-muted)]'>Nenhuma oportunidade registrada.</p>
        )}
      </ul>
    </CsSection>
  )
}
